import { useEmployeeSuggestionsService } from 'domain/shared/employee';
import useEmployeeData from '../hooks/useEmployeeData';
import type { EmployeeData } from '../hooks/useEmployeeData';

interface ContactsEmployeeService {
  useEmployeeSuggestions: typeof useEmployeeSuggestionsService;
  useEmployeeData: (employeeId?: string) => { data: EmployeeData | null; loading: boolean };
  searchHRManagers: () => Promise<any[]>;
  searchPeopleManagers: () => Promise<any[]>;
}

const useContactsEmployeeService = (): ContactsEmployeeService => {
  const { search } = useEmployeeSuggestionsService();

  const searchHRManagers = async () => {
    try {
      const result = await search({
        filter: {
          'specification:isHrManager': { eq: true },
        },
      });
      return result.result || [];
    } catch (error) {
      return [];
    }
  };

  const searchPeopleManagers = async () => {
    try {
      const result = await search({
        filter: {
          'specification:generalPeopleManagerSpecification': { eq: true },
        },
      });
      return result.result || [];
    } catch (error) {
      return [];
    }
  };

  return {
    useEmployeeSuggestions: useEmployeeSuggestionsService,
    useEmployeeData,
    searchHRManagers,
    searchPeopleManagers,
  };
};

export default useContactsEmployeeService;
